import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { onKeyDown } from '../../utils/expand-on-keydown.js';

const OpenCloseIndication = (_param)=>{
    var { labels , status , hours , isExpanded , onExpand  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "labels",
        "status",
        "hours",
        "isExpanded",
        "onExpand"
    ]);
     return React.createElement("button", swcHelpers.extends({}, rest, {
        "data-t": "OpenCloseIndication",
        className: classnames('open-close-indication', {
            'open-close-indication--expandable': Boolean(onExpand)
        }),
        tabIndex: Boolean(onExpand) ? 0 : -1,
        onClick: onExpand,
        onKeyDown: (e)=>onKeyDown(e, onExpand)
        ,
        "aria-expanded": isExpanded
    }), /*#__PURE__*/ React.createElement("p", {
        className: classnames('open-close-indication__indication', {
            [`open-close-indication__indication--${status.toLowerCase()}`]: true
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: "open-close-indication__status"
    }, labels.status), labels.indication, ' ', hours === null || hours === void 0 ? void 0 : hours.map((timePair)=>/*#__PURE__*/ React.createElement("span", {
            key: timePair.toString(),
            className: "open-close-indication__time-pair"
        }, timePair.length > 1 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("time", {
            dateTime: timePair[0]
        }, timePair[0]), ` - `, /*#__PURE__*/ React.createElement("time", {
            dateTime: timePair[1]
        }, timePair[1])) : /*#__PURE__*/ React.createElement("time", {
            key: timePair[0],
            dateTime: timePair[0]
        }, timePair[0]))
    )), onExpand && /*#__PURE__*/ React.createElement(Icon, {
        width: 16,
        height: 16,
        className: "open-close-indication__icon",
        name: isExpanded ? 'chevron-up' : 'chevron-down'
    }));
};

export { OpenCloseIndication as default };
//# sourceMappingURL=OpenCloseIndication.js.map
